module.exports = __webpack_public_path__ + "img/Essenza Cofani - Logo.9005d4fd.png";